import React from "react";

const GlobalModalContext = React.createContext({});

export default GlobalModalContext;
